import { ContentNodeType } from "../../editor-config-context";
import { ContentNodeDefinition } from "../types";

const SnippetDefinition: ContentNodeDefinition = {
  nodeType: ContentNodeType.Snippet,
  regex: /@@@(.+?)?@@@/g,
  toXML: content => {
    const match = content[1] ?? "";
    const parts = match.split(/(@version_number:|@label:)/);
    const name = parts[0].replace(/^@@@/, "").replace(/@@@$/, "");
    let version_number, label;
    let props = "mounted='true'";
    for (let i = 1; i < parts.length; i += 2) {
      if (parts[i] === "@version_number:") {
        version_number = parts[i + 1].replace(/@@@$/, "");
      } else if (parts[i] === "@label:") {
        label = parts[i + 1].replace(/@@@$/, "");
      }
    }

    if (name) {
      props += ` name="${name}"`;
    }
    if (version_number) {
      props += ` version_number="${version_number}"`;
    }
    if (label) {
      props += ` label="${label}"`;
    }

    return `<snippet ${props}></snippet>`;
  },
};

export default SnippetDefinition;
